import React from 'react';
import PropTypes from 'prop-types';

const TwoColumns = ({ column1, column2 }) => (
  <div className="grid grid-cols-[1fr_1fr] grid-rows-[auto] gap-6 [grid-template-areas:'TwoColumns__column1_TwoColumns__column2']">
    <div className="[grid-area:TwoColumns__column1]">{column1}</div>
    <div className="[grid-area:TwoColumns__column2]">{column2}</div>
  </div>
);

TwoColumns.propTypes = {
  column1: PropTypes.node,
  column2: PropTypes.node,
};

export default TwoColumns;
